const TabHeader = ({ heading, onClick, customCss, isActive }) => {
  return (
    <div onClick={onClick}>
      <label
        className={`cursor-pointer py-2 max-[315px]:text-sm max-[290px]:text-xs ${
          isActive
            ? "border-b-[2px] border-[#5A1E66] text-[#5A1E66]"
            : "text-gray-500"
        } ${customCss}`}
      >
        {heading}
      </label>
    </div>
  );
};

export default TabHeader;
